import { RuleTypeEnum } from "../../../domain/RuleType";
import { YoutubeChannelRuleValue } from "../../../domain/ruleValue/YoutubeChannelRuleValue";
import { RuleValueStore, SerializedRuleValueStore } from "../RuleValueStore";

export class YoutubeChannelRuleValueStore implements RuleValueStore<RuleTypeEnum.YOUTUBE_CHANNEL> {
    allowedChannelIds: Set<string>;
    deniedChannelIds: Set<string>;

    constructor() {
        this.allowedChannelIds = new Set();
        this.deniedChannelIds = new Set();
    }

    add(ruleValue: YoutubeChannelRuleValue): void {
        if (ruleValue.action.isAllow()) {
            this.allowedChannelIds.add(ruleValue.getValue().youtubeChannelId);
        } else {
            this.deniedChannelIds.add(ruleValue.getValue().youtubeChannelId);
        }
    }

    serialize(): SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_CHANNEL> {
        const data: SerializedYoutubeChannelRuleValueStoreData = {
            allowedChannelIds: Array.from(this.allowedChannelIds),
            deniedChannelIds: Array.from(this.deniedChannelIds),
        };
        return {
            type: RuleTypeEnum.YOUTUBE_CHANNEL,
            data: data,
        };
    }

    fromSerialized(serialized: SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_CHANNEL>): void {
        this.allowedChannelIds = new Set(serialized.data.allowedChannelIds);
        this.deniedChannelIds = new Set(serialized.data.deniedChannelIds);
    }

    evaluateYoutubeChannelId(channelId: string): YoutubeChannelRuleValueStoreEvaluationResult {
        // Check whitelist
        if (this.allowedChannelIds.has(channelId)) return "ALLOWED";

        // Check blacklist
        if (this.deniedChannelIds.has(channelId)) return "DENIED";

        return "NO_MATCH";
    }
}

export interface SerializedYoutubeChannelRuleValueStoreData {
    allowedChannelIds: string[];
    deniedChannelIds: string[];
};

export type YoutubeChannelRuleValueStoreEvaluationResult = "ALLOWED" | "DENIED" | "NO_MATCH"